import React, { useState, useEffect, useCallback } from 'react';
import ClientProvider from '../../../Various/ClientProvider';

export const useWebsiteAuditLogs = (websiteHash, isModalOpen) => {
    const [logs, setLogs] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [error, setError] = useState(null);

    const wsProvider = React.useContext(ClientProvider);
    const websocketClient = wsProvider?.ws;

    const fetchLogs = useCallback(() => {
        if (!websiteHash || !websocketClient || !isModalOpen) {
            return;
        }

        setIsLoading(true);
        setError(null);

        websocketClient.waitForSocketAndSend({
            action: "getWebsiteAuditLog",
            options: {
                url_hash: websiteHash
            }
        }, (response) => {
            setIsLoading(false);
            
            if (response.error) {
                setError(response.error);
                setLogs([]);
            } else if (response.status === 'success' && Array.isArray(response.audit_log)) {
                setLogs(response.audit_log);
            } else if (Array.isArray(response.audit_log)) {
                setLogs(response.audit_log);
            } else if (Array.isArray(response.logs)) {
                setLogs(response.logs);
            } else if (Array.isArray(response)) {
                setLogs(response);
            } else {
                setLogs([]);
            }
        });
    }, [websiteHash, websocketClient, isModalOpen]);

    useEffect(() => {
        if (isModalOpen && websiteHash) {
            fetchLogs();
        } else {
            setLogs([]);
            setError(null);
        }
    }, [isModalOpen, websiteHash, fetchLogs]);

    return {
        logs,
        isLoading,
        error
    };
};

